import React, { Fragment } from "react";
import PRZInput from "../../../../UI/PRZInput";
import PRZSelect from "../../../../UI/PRZSelect";
import "./style.scss";
import PRZDatePicker from "../../../../UI/PRZDatePicker";

const PRZAdvanceFilterCustomInputs = ({
  value,
  containerClassName,
  entityType,
  placeholder,
  onChange,
  dropdownOptions,
  inputType,
  wrapperClassName,
  className,
}) => {
  return (
    <Fragment>
      <div className={containerClassName}>
        {["NUMBERS", "TEXT", "NUMBER", "TEXT_AREA"].includes(entityType) && (
          <div style={{ display: "flex" }}>
            <PRZInput
              value={value[0]}
              placeholder={placeholder}
              onChange={(e) => onChange(e.target.value, 0)}
              className={className}
              wrapperClassName={wrapperClassName}
            />
            {inputType === "range" && (
              <PRZInput
                value={value[1]}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value, 1)}
                wrapperClassName={wrapperClassName}
                className={className}
                type="number"
              />
            )}
          </div>
        )}
        {["CHECKBOX", "DROPDOWN"].includes(entityType) && (
          <PRZSelect
            className={className}
            wrapperClassName={wrapperClassName}
            value={value[0]}
            options={dropdownOptions?.map((item) => ({
              ...item,
              value: item,
              label: item,
            }))}
            placeholder="Select Operator"
            size="middle"
            allowClear
            onChange={(selectedValue) => onChange(selectedValue, 0)}
            showSearch
            mode="multiple"
            maxTagCount="responsive"
          />
        )}
        {entityType === "DATE" &&
          inputType === "range" &&
          (
            <PRZDatePicker
              value={value}
              wrapperStyle={{ width: "250px" }}
              startDate={value[0]}
              endDate={value[1]}
              onChange={(date) => {
                onChange(date, 0);
              }}
              type="range"
              format="DD-MM-YYYY"
            />
          )}

        {entityType === "DATE" && inputType === "single" && (
          <PRZDatePicker
            className={className}
            wrapperClassName={wrapperClassName}
            value={value[0]}
            onChange={(selectedValue) => {
              onChange(selectedValue, 0);
            }}
            type="single"
            format="DD-MM-YYYY"
          />
        )}

      </div>
    </Fragment>
  );
};

export default PRZAdvanceFilterCustomInputs;
